import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import CustomToast from '../../utils/CustomToast';
import { getRememberedInvite, forgetInvite, acceptInvite, isRetryableInviteError } from '../../utils/entryInvite';

// Mounted once in App.js. When someone opened an invite link before they had an account,
// this accepts the invite as soon as they are logged in, wherever the login flow lands them.
const PendingInviteClaimer = () => {
  const [cookies] = useCookies(['currentUser', 'token']);
  const location = useLocation();
  const history = useHistory();
  const attemptedFor = useRef(null);

  useEffect(() => {
    const invite = getRememberedInvite();
    const { currentUser, token } = cookies;

    // The accept page handles its own token; only try once per logged-in user
    if (!invite || !currentUser || !token || location.pathname.startsWith('/entrant/invite')) return;
    if (attemptedFor.current === currentUser) return;
    attemptedFor.current = currentUser;

    acceptInvite(invite, currentUser, token)
      .then(({ data }) => {
        if (data.status === 'Success') {
          forgetInvite();
          CustomToast.success(`You now have access to ${data.data.entry_name || 'the entry'}.`);
          history.push(`/entrant/entry/details?entry_id=${data.data.entry_id}`);
        } else {
          if (!isRetryableInviteError(data.code)) forgetInvite();
          if (data.errors && data.errors[0]) CustomToast.error(data.errors[0]);
        }
      })
      .catch(() => {});
  }, [location.pathname, cookies.currentUser, cookies.token]);

  return null;
};

export default PendingInviteClaimer;
